import { PRODUCT_PAGE_SET_SELECTED_VARIANT } from '../constants';

const defaultState = {
  selectedVariant: null,
};

export const productPage = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_PAGE_SET_SELECTED_VARIANT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
